import type { CampaignRow } from "@/api/hooks/adsManager"

function firstNonEmptyString(values: unknown[]): string | null {
  for (const value of values) {
    if (typeof value === "string" && value.trim().length > 0) {
      return value
    }
  }
  return null
}

/** Roots-only placeholder rows until TikTok sync links a real campaign id. */
export function isRootsPlaceholderCampaign(row: CampaignRow): boolean {
  const id = String(row.campaign_id ?? "")
  return id.startsWith("ROOTS-")
}

export function getCampaignAccountName(row: CampaignRow): string {
  if (isRootsPlaceholderCampaign(row)) {
    return "Unknown"
  }

  // API responses are not fully consistent across tabs/endpoints,
  // so we support known alternative keys before falling back to ID.
  const fromCanonical = firstNonEmptyString([row.account_name])
  if (fromCanonical) return fromCanonical

  const fromAliases = firstNonEmptyString([
    row["advertiser_name"],
    row["account"],
    row["accountTitle"],
    row["account_label"],
  ])
  if (fromAliases) return fromAliases

  return row.advertiser_id
}
